export default "__VITE_ASSET__Ddnfd4N1__"